<div class="products-main  content-web-section">
  <div class="col-lg-12 row ">
    <div class="col-lg-12 row tabs-group">
      <div class="tab-container-1 ">
        <div class="col-lg-12 col-md-12 row">
          <div class="col-lg-1 col-md-1 col-xs-12"></div>
          <div class="col-lg-2 col-md-2 col-xs-12 tab-set cursor-pointer radius-left text-center" [ngClass]="{'active-tab':activeTab==='all'}"
          (click)="setActive('all')">
            All Funds ({{fundsData.length}})
            <span class="tab-seperator"></span>
          </div>
          <div class="col-lg-2 col-md-2 col-xs-12 tab-set cursor-pointer text-center" [ngClass]="{'active-tab':activeTab==='equity'}"
          (click)="setActive('equity')">
            Equity Funds ({{equityCount}})
            <span class="tab-seperator"></span>
          </div>
          <div class="col-lg-2 col-md-2 col-xs-12 tab-set cursor-pointer text-center" [ngClass]="{'active-tab':activeTab==='debt'}" (click)="setActive('debt')">
            Debt Funds ({{debtCount}})
            <span class="tab-seperator"></span>
          </div>
          <div class="col-lg-2 col-md-2 col-xs-12 tab-set cursor-pointer text-center" [ngClass]="{'active-tab':activeTab==='hybrid'}"
          (click)="setActive('hybrid')">
            Hybrid Funds ({{hyBridCount}})
            <span class="tab-seperator"></span>
          </div>
          <div class="col-lg-2 col-md-2 col-xs-12 tab-set cursor-pointer radius-right text-center" [ngClass]="{'active-tab':activeTab==='other'}"
          (click)="setActive('other')">
            Others ({{otherCount}})
          </div>
          <!-- <div class="col-lg-1 col-md-1 col-xs-12"></div> -->
        </div>

      </div>
      <div class="tab-container-2">
        <span class="right-content">
          <span class="select-label">Scheme Plan : </span>
          <select class="select-data" (change)="setPlan($event.target.value)">
            <option *ngFor="let item of schemeType" [value]="item.value">{{item.displayName}}</option>
          </select>
        </span>
      </div>
    </div>

    <div class="tab-content py-3 px-3 px-sm-0 col-lg-12 row" >
      <!-- <div class="col-lg-12 row"> -->
        <div class="col-lg-3 ">
          <div class="col-lg-12 filters-section">
            <img src="assets/icons/icon_filter.png"><span class="filters-header"> Filters</span>
            <hr>
            <span *ngFor="let item of filtersData;let lastMain=last">
              <div class="filter-sub-section mb-2">{{item.heading}}</div>
              <div *ngFor="let subItem of item.datas;let i=index;let last=last">
                <input type="checkbox" class="filter-check-box cursor-pointer" [value]="subItem.value" (change)="applyFilters($event,item.name,subItem.value)">
                <span class="filter-check-box-text">{{subItem.displayName}}</span>
                <hr *ngIf="last && !lastMain">
              </div>

            </span>
          </div>
        </div>
        <div class="col-lg-9">
          <div *ngIf="activeTab==='all'">
            <div class="col-lg-12 row">
              <div class="col-lg-6  mobile-padding-top " *ngFor="let item of fundsData;let i=index">
                <div class="individual-funds">
                  <div class="top-right-corner"
                  [ngClass]="{'top-right-corner-l': item.risk==='Low', 'top-right-corner-mh': item.risk==='Moderate' || item.risk==='Moderately High'  || item.risk==='Moderately Low' || item.risk==='Low to Moderate','top-right-corner-m': item.risk==='High' || item.risk==='Very High'}">
                    <span class="risk-text"> {{item.risk}} Risk </span>
                  </div>
                  <span class="fund-heading">{{item.fundType}}</span>
                  <span class="growth-section">  {{splitString(item.plan)}}</span>
                  <br>
                  <span class="fund-heading-2">{{item.scheme}} </span><br>
                  <div class="fund-text">{{item.description}}</div><br>
                  <hr class="hr-line">
                  <span class="fund-date" *ngIf="item.currentDate"> As on {{commonDataService.customDate(item.currentDate)}} </span><br>
                  <span class="fund-date" *ngIf="!item.currentDate"> NA </span><br>
                  <span class="date-text">NAV &nbsp; &#8377;  {{item.nav  }}</span> &nbsp;
                   <img src="assets/icons/up_arrow.png" class="img-width" *ngIf="item.navPercent>=0">
       <img src="assets/icons/down_arrow.png" class="img-width" *ngIf="item.navPercent<0">
                  <span [ngClass]="{'date-vals': item.navPercent>=0,'date-vals-low': item.navPercent<0}">( {{item.navPercent | number : '1.2-2'}}% )</span>
                  <hr class="hr-line">
                  <span class="caption-cag">CAGR</span><br><br>
                  <div class="d-flex">
                    <div class="years-data">
                      <span *ngIf="item?.cagrYear[0]?.one"> 
                        <span class="years-share-val " [ngClass]="{'data-red': item.cagrYear[0].one<0,  'data-green': item.cagrYear[0].one>=0}" > 
                          <ng-template [ngIf]="item.cagrYear[0].one === 'NA'">
                            <span>NA</span>
                          </ng-template>
                          <ng-template [ngIf]="item.cagrYear[0].one !== 'NA'">
                            <span> {{item.cagrYear[0].one}}%</span>
                          </ng-template>
                        </span>
                      </span>
                      <span *ngIf="!item?.cagrYear[0]?.one">-</span>
                      <br>
                        <span class="years-share-text"> (Last 1 Year)</span>
                    </div>
                    <div class="years-data">
                      &nbsp;   <span *ngIf="item?.cagrYear[0]?.three">
                        <span class="years-share-val " [ngClass]="{'data-red': item.cagrYear[0].three<0,  'data-green': item.cagrYear[0].three>=0}"> 
                          <ng-template [ngIf]="item.cagrYear[0].three === 'NA'">
                            <span>NA</span>
                          </ng-template>
                          <ng-template [ngIf]="item.cagrYear[0].three !== 'NA'">
                            <span> {{item.cagrYear[0].three}}%</span>
                          </ng-template>
                        </span>
                      </span>
                      <span *ngIf="!item?.cagrYear[0]?.three">-</span>
                      <br>
                      &nbsp;<span class="years-share-text"> (Last 3 Years)</span>
                    </div>
                    <div class="years-data">
                      &nbsp;    <span *ngIf="item?.cagrYear[0]?.five">
                        <span class="years-share-val " [ngClass]="{'data-red': item.cagrYear[0].three<0,  'data-green': item.cagrYear[0].three>=0}"> 
                          <ng-template [ngIf]="item.cagrYear[0].five === 'NA'">
                            <span>NA</span>
                          </ng-template>
                          <ng-template [ngIf]="item.cagrYear[0].five !== 'NA'">
                            <span> {{item.cagrYear[0].five}}%</span>
                          </ng-template>
                        </span>
                      </span>
                      <span *ngIf="!item?.cagrYear[0]?.five">-</span>
                      <br>
                      &nbsp; <span class="years-share-text"> (Last 5 Years)</span>
                    </div>
                </div>
                  <span class="seperator"></span>
                  <hr class="hr-line">
                  <!-- <br> -->
                  <div class="align-h">
                    <div class="stretch">
                    <button type="button" (click)="investOnline()" class="common-submit-button-banner cursor-pointer">Invest Now</button>
                   </div>
                   <div class="margin-right-15">
                    <button type="button" id="invest-now" (click)="viewDetails(item.scheme, item)" class="common-submit-button-banner cursor-pointer btn-color-black margin-left-15">Explore</button>
                  </div>
                  </div>
                  <br><br>
                </div>
              </div>

            </div>
            <div class="no-fund text-center" *ngIf="!fundsData || fundsData.length<=0">No Funds available</div>
          </div>
          <div *ngIf="activeTab==='equity'">
            <div class="col-lg-12 row">
              <ng-container  *ngFor="let item of fundsData;let i=index">
              <div class="col-lg-6  mobile-padding-top " *ngIf="item.fundType==='Equity'">
                <div class="col-lg-12 individual-funds">
                  <div class="top-right-corner"
                  [ngClass]="{'top-right-corner-l': item.risk==='Low', 'top-right-corner-mh': item.risk==='Moderate' || item.risk==='Moderately High'  || item.risk==='Moderately Low' ,'top-right-corner-m': item.risk==='High'}">
                    <span class="risk-text">{{item.risk}} Risk</span>
                  </div>
                  <span class="fund-heading">{{item.fundType}}</span>
                  <span class="growth-section">  {{splitString(item.plan)}}</span>
                  <br>
                  <span class="fund-heading-2">{{item.scheme}} </span><br>
                  <div class="fund-text">{{item.description}}</div><br>
                  <hr class="hr-line">
                  <span class="fund-date" *ngIf="item.currentDate"> As on {{commonDataService.customDate(item.currentDate)}} </span><br>
                  <span class="fund-date" *ngIf="!item.currentDate"> NA </span><br>
                  <span class="date-text">NAV &nbsp; &#8377; {{item.nav }}</span> &nbsp;
                   <img src="assets/icons/up_arrow.png" class="img-width" *ngIf="item.navPercent>=0">
       <img src="assets/icons/down_arrow.png" class="img-width"  *ngIf="item.navPercent<0">
                  <span [ngClass]="{'date-vals': item.navPercent>=0,'date-vals-low': item.navPercent<0}">( {{item.navPercent | number : '1.2-2'}}% )</span>
                  <hr class="hr-line">
                  <span class="caption-cag">CAGR</span><br><br>
                  <div class="d-flex">
                    <div class="years-data">
                      <span *ngIf="item?.cagrYear[0]?.one"> 
                        <span class="years-share-val " [ngClass]="{'data-red': item.cagrYear[0].one<0,  'data-green': item.cagrYear[0].one>=0}" > 
                        <ng-template [ngIf]="item?.cagrYear[0]?.one === 'NA'">
                            <span>NA</span>
                        </ng-template>
                        <ng-template [ngIf]="item?.cagrYear[0]?.one !== 'NA'">
                          <span>{{item.cagrYear[0].one}}%</span>
                        </ng-template>
                        </span>
                      </span>
                      <span *ngIf="!item?.cagrYear[0]?.one">-</span>
                      <br>
                        <span class="years-share-text"> (Last 1 Year)</span>
                    </div>
                    <div class="years-data">
                      &nbsp;   <span *ngIf="item?.cagrYear[0]?.three">
                        <span class="years-share-val " [ngClass]="{'data-red': item.cagrYear[0].three<0,  'data-green': item.cagrYear[0].three>=0}"> 
                          <ng-template [ngIf]="item?.cagrYear[0]?.three === 'NA'">
                            <span>NA</span>
                        </ng-template>
                        <ng-template [ngIf]="item?.cagrYear[0]?.three !== 'NA'">
                          <span>{{item.cagrYear[0].three}}%</span>
                        </ng-template>
                        </span>
                      </span>
                      <span *ngIf="!item?.cagrYear[0]?.three">-</span>
                      <br>
                      &nbsp;<span class="years-share-text"> (Last 3 Years)</span>
                    </div>
                    <div class="years-data">
                      &nbsp;    <span *ngIf="item?.cagrYear[0]?.five">
                        <span class="years-share-val " [ngClass]="{'data-red': item.cagrYear[0].five<0,  'data-green': item.cagrYear[0].five>=0}"> 
                          <ng-template [ngIf]="item?.cagrYear[0]?.five === 'NA'">
                            <span>NA</span>
                        </ng-template>
                        <ng-template [ngIf]="item?.cagrYear[0]?.five !== 'NA'">
                          <span>{{item.cagrYear[0].five}}%</span>
                        </ng-template>
                        </span>
                        </span>
                      <span *ngIf="!item?.cagrYear[0]?.five">-</span>
                      <br>
                      &nbsp; <span class="years-share-text"> (Last 5 Years)</span>
                    </div>
                </div>
                  <span class="seperator"></span>
                  <hr class="hr-line">
                  <!-- <br> -->
                  <div class="align-h">
                    <div class="stretch">
                    <button type="button" (click)="investOnline()" class="common-submit-button-banner cursor-pointer">Invest Now</button>
                   </div>
                   <div>
                    <button type="button" id="invest-now" (click)="viewDetails(item.scheme, item)" class="common-submit-button-banner cursor-pointer btn-color-black margin-left-15">Explore</button>
                  </div>
                  </div>
                  <br><br>
                </div>
              </div>
            </ng-container>

            </div>
            <div class="no-fund text-center" *ngIf="equityCount<=0">No Funds available</div>
          </div>
          <div *ngIf="activeTab==='debt'">
            <div class="col-lg-12 row">
              <ng-container  *ngFor="let item of fundsData;let i=index">
              <div class="col-lg-6  mobile-padding-top " *ngIf="item.fundType==='Debt'">
                <div class="col-lg-12 individual-funds">
                  <div class="top-right-corner"
                  [ngClass]="{'top-right-corner-l': item.risk==='Low', 'top-right-corner-mh': item.risk==='Moderate' || item.risk==='Moderately High'  || item.risk==='Moderately Low' ,'top-right-corner-m': item.risk==='High'}">
                    <span class="risk-text">{{item.risk}} Risk</span>
                  </div>
                  <span class="fund-heading">{{item.fundType}}</span>
                  <span class="growth-section">  {{splitString(item.plan)}}</span>
                  <br>
                  <span class="fund-heading-2">{{item.scheme}} </span><br>
                  <div class="fund-text">{{item.description}}</div><br>
                  <hr class="hr-line">
                  <span class="fund-date" *ngIf="item.currentDate"> As on {{commonDataService.customDate(item.currentDate)}} </span><br>
                  <span class="fund-date" *ngIf="!item.currentDate"> NA </span><br>
                  <span class="date-text">NAV &nbsp; &#8377;  {{item.nav}}</span> &nbsp;
                   <img src="assets/icons/up_arrow.png" class="img-width" *ngIf="item.navPercent>=0">
       <img src="assets/icons/down_arrow.png" class="img-width" *ngIf="item.navPercent<0">
                  <span [ngClass]="{'date-vals': item.navPercent>=0,'date-vals-low': item.navPercent<0}">( {{item.navPercent | number : '1.2-2'}}% )</span>
                  <hr class="hr-line">
                  <span class="caption-cag">CAGR</span><br><br>
                  <div class="d-flex">
                    <div class="years-data">
                      <span *ngIf="item?.cagrYear[0]?.one"> 
                        <span class="years-share-val " [ngClass]="{'data-red': item.cagrYear[0].one<0,  'data-green': item.cagrYear[0].one>=0}" > 
                          <ng-template [ngIf]="item.cagrYear[0].one === 'NA'">
                            <span>NA</span>
                          </ng-template>
                          <ng-template [ngIf]="item.cagrYear[0].one !== 'NA'">
                            <span>{{item.cagrYear[0].one}}%</span>
                          </ng-template>
                        </span>
                      </span>
                      <span *ngIf="!item?.cagrYear[0]?.one">-</span>
                      <br>
                        <span class="years-share-text"> (Last 1 Year)</span>
                    </div>
                    <div class="years-data">
                      &nbsp;   <span *ngIf="item?.cagrYear[0]?.three">
                        <span class="years-share-val " [ngClass]="{'data-red': item.cagrYear[0].three<0,  'data-green': item.cagrYear[0].three>=0}"> 
                          <ng-template [ngIf]="item.cagrYear[0].three === 'NA'">
                            <span>NA</span>
                          </ng-template>
                          <ng-template [ngIf]="item.cagrYear[0].three !== 'NA'">
                            <span>{{item.cagrYear[0].one}}%</span>
                          </ng-template>
                        </span>
                      </span>
                      <span *ngIf="!item?.cagrYear[0]?.three">-</span>
                      <br>
                      &nbsp;<span class="years-share-text"> (Last 3 Years)</span>
                    </div>
                    <div class="years-data">
                      &nbsp;    <span *ngIf="item?.cagrYear[0]?.five">
                        <span class="years-share-val " [ngClass]="{'data-red': item.cagrYear[0].three<0,  'data-green': item.cagrYear[0].three>=0}"> 
                          <ng-template [ngIf]="item.cagrYear[0].five === 'NA'">
                            <span>NA</span>
                          </ng-template>
                          <ng-template [ngIf]="item.cagrYear[0].five !== 'NA'">
                            <span>{{item.cagrYear[0].one}}%</span>
                          </ng-template>
                        </span>
                      </span>
                      <span *ngIf="!item?.cagrYear[0]?.five">-</span>
                      <br>
                      &nbsp; <span class="years-share-text"> (Last 5 Years)</span>
                    </div>
                </div>
                  <span class="seperator"></span>
                  <hr class="hr-line">
                  <!-- <br> -->
                  <div class="align-h">
                    <div class="stretch">
                    <button type="button" (click)="investOnline()" class="common-submit-button-banner cursor-pointer">Invest Now</button>
                   </div>
                   <div>
                    <button type="button" id="invest-now" (click)="viewDetails(item.scheme, item)" class="common-submit-button-banner cursor-pointer btn-color-black margin-left-15">Explore</button>
                  </div>
                  </div>
                  <br><br>
                </div>
              </div>
            </ng-container>

            </div>
            <div class="no-fund text-center" *ngIf="debtCount<=0">No Funds available</div>
          </div>
          <div *ngIf="activeTab==='hybrid'">
            <div class="col-lg-12 row">
              <ng-container  *ngFor="let item of fundsData;let i=index">
              <div class="col-lg-6  mobile-padding-top " *ngIf="item.fundType==='Hybrid'">
                <div class="col-lg-12 individual-funds">
                  <div class="top-right-corner"
                  [ngClass]="{'top-right-corner-l': item.risk==='Low', 'top-right-corner-mh': item.risk==='Moderate' || item.risk==='Moderately High'  || item.risk==='Moderately Low' ,'top-right-corner-m': item.risk==='High'}">
                    <span class="risk-text">{{item.risk}} Risk</span>
                  </div>
                  <span class="fund-heading">{{item.fundType}}</span>
                  <span class="growth-section">  {{splitString(item.plan)}}</span>
                  <br>
                  <span class="fund-heading-2">{{item.scheme}} </span><br>
                  <div class="fund-text">{{item.description}}</div><br>
                  <hr class="hr-line">
                  <span class="fund-date" *ngIf="item.currentDate"> As on {{commonDataService.customDate(item.currentDate)}} </span><br>
                  <span class="fund-date" *ngIf="!item.currentDate"> NA </span><br>
                  <span class="date-text">NAV &nbsp; &#8377;  {{item.nav}}</span> &nbsp;
                   <img src="assets/icons/up_arrow.png" class="img-width" *ngIf="item.navPercent>=0">
       <img src="assets/icons/down_arrow.png" class="img-width" *ngIf="item.navPercent<0">
                  <span [ngClass]="{'date-vals': item.navPercent>=0,'date-vals-low': item.navPercent<0}">( {{item.navPercent | number : '1.2-2'}}% )</span>
                  <hr class="hr-line">
                  <span class="caption-cag">CAGR</span><br><br>
                  <div class="d-flex">
                    <div class="years-data">
                      <span *ngIf="item?.cagrYear[0]?.one"> 
                        <span class="years-share-val " [ngClass]="{'data-red': item.cagrYear[0].one<0,  'data-green': item.cagrYear[0].one>=0}" > 
                          <ng-template [ngIf]="item.cagrYear[0].one === 'NA'">
                            <span>NA</span>
                          </ng-template>
                          <ng-template [ngIf]="item.cagrYear[0].one !== 'NA'">
                            <span>{{item.cagrYear[0].one}}%</span>
                          </ng-template>
                        </span>
                      </span>
                      <span *ngIf="!item?.cagrYear[0]?.one">-</span>
                      <br>
                        <span class="years-share-text"> (Last 1 Year)</span>
                    </div>
                    <div class="years-data">
                      &nbsp;   <span *ngIf="item?.cagrYear[0]?.three">
                        <span class="years-share-val " [ngClass]="{'data-red': item.cagrYear[0].three<0,  'data-green': item.cagrYear[0].three>=0}">
                          <ng-template [ngIf]="item.cagrYear[0].three === 'NA'">
                            <span>NA</span>
                          </ng-template>
                          <ng-template [ngIf]="item.cagrYear[0].three !== 'NA'">
                            <span>{{item.cagrYear[0].three}}%</span>
                          </ng-template>
                        </span>
                      </span>
                      <span *ngIf="!item?.cagrYear[0]?.three">-</span>
                      <br>
                      &nbsp;<span class="years-share-text"> (Last 3 Years)</span>
                    </div>
                    <div class="years-data">
                      &nbsp;    <span *ngIf="item?.cagrYear[0]?.five">
                        <span class="years-share-val " [ngClass]="{'data-red': item.cagrYear[0].three<0,  'data-green': item.cagrYear[0].three>=0}">
                          <ng-template [ngIf]="item.cagrYear[0].five === 'NA'">
                            <span>NA</span>
                          </ng-template>
                          <ng-template [ngIf]="item.cagrYear[0].five !== 'NA'">
                            <span>{{item.cagrYear[0].five}}%</span>
                          </ng-template>
                        </span>
                      </span>
                      <span *ngIf="!item?.cagrYear[0]?.five">-</span>
                      <br>
                      &nbsp; <span class="years-share-text"> (Last 5 Years)</span>
                    </div>
                </div>
                  <span class="seperator"></span>
                  <hr class="hr-line">
                  <!-- <br> -->
                  <div class="align-h">
                    <div class="stretch">
                    <button type="button" (click)="investOnline()" class="common-submit-button-banner cursor-pointer">Invest Now</button>
                   </div>
                   <div>
                    <button type="button" id="invest-now" (click)="viewDetails(item.scheme, item)" class="common-submit-button-banner cursor-pointer btn-color-black margin-left-15">Explore</button>
                  </div>
                  </div>
                  <br><br>
                </div>
              </div>
            </ng-container>

            </div>
            <div class="no-fund text-center" *ngIf="hyBridCount<=0">No Funds available</div>
          </div>
          <div *ngIf="activeTab==='other'">
            <div class="col-lg-12 row">
              <ng-container  *ngFor="let item of fundsData;let i=index">
              <div class="col-lg-6  mobile-padding-top " *ngIf="item.fundType!=='Equity' && item.fundType!=='Debt' && item.fundType!=='Hybrid' ">
                <div class="col-lg-12 individual-funds">
                  <div class="top-right-corner"
                  [ngClass]="{'top-right-corner-l': item.risk==='Low', 'top-right-corner-mh': item.risk==='Moderate' || item.risk==='Moderately High'  || item.risk==='Moderately Low' ,'top-right-corner-m': item.risk==='High'}">
                    <span class="risk-text">{{item.risk}} Risk</span>
                  </div>
                  <span class="fund-heading">{{item.fundType}}</span>
                  <span class="growth-section">  {{splitString(item.plan)}}</span>
                  <br>
                  <span class="fund-heading-2">{{item.scheme}} </span><br>
                  <div class="fund-text">{{item.description}}</div><br>
                  <hr class="hr-line">
                  <span class="fund-date" *ngIf="item.currentDate"> As on {{commonDataService.customDate(item.currentDate)}}</span><br>
                  <span class="fund-date" *ngIf="!item.currentDate"> NA </span><br>
                  <span class="date-text">NAV &nbsp; &#8377;  {{item.nav}}</span> &nbsp;
                  <img src="assets/icons/up_arrow.png" class="img-width" *ngIf="item.navPercent>=0">
                  <img src="assets/icons/down_arrow.png" class="img-width"  *ngIf="item.navPercent<0">
                  <span [ngClass]="{'date-vals': item.navPercent>=0,'date-vals-low': item.navPercent<0}">( {{item.navPercent | number : '1.2-2'}}% )</span>
                  <hr class="hr-line">
                  <span class="caption-cag">CAGR</span><br><br>
                  <div class="d-flex">
                    <div class="years-data">
                      <span *ngIf="item?.cagrYear[0]?.one"> 
                        <span class="years-share-val " [ngClass]="{'data-red': item.cagrYear[0].one<0,  'data-green': item.cagrYear[0].one>=0}" >
                           <ng-template [ngIf]="item.cagrYear[0].one === 'NA'">
                             <span>NA</span>
                           </ng-template>
                           <ng-template [ngIf]="item.cagrYear[0].one !== 'NA'">
                            <span>{{item.cagrYear[0].one}}%</span>
                          </ng-template>
                          </span>
                        </span>
                      <span *ngIf="!item?.cagrYear[0]?.one">-</span>
                      <br>
                        <span class="years-share-text"> (Last 1 Year)</span>
                    </div>
                    <div class="years-data">
                      &nbsp;   <span *ngIf="item?.cagrYear[0]?.three">
                        <span class="years-share-val " [ngClass]="{'data-red': item.cagrYear[0].three<0,  'data-green': item.cagrYear[0].three>=0}"> 
                          <ng-template [ngIf]="item.cagrYear[0].three === 'NA'">
                            <span>NA</span>
                          </ng-template>
                          <ng-template [ngIf]="item.cagrYear[0].three !== 'NA'">
                           <span>{{item.cagrYear[0].three}}%</span>
                         </ng-template>
                        </span>
                      </span>
                      <span *ngIf="!item?.cagrYear[0]?.three">-</span>
                      <br>
                      &nbsp;<span class="years-share-text"> (Last 3 Years)</span>
                    </div>
                    <div class="years-data">
                      &nbsp;    <span *ngIf="item?.cagrYear[0]?.five"><span class="years-share-val " [ngClass]="{'data-red': item.cagrYear[0].three<0,  'data-green': item.cagrYear[0].three>=0}"> {{item.cagrYear[0].five}}%</span></span>
                      <span *ngIf="!item?.cagrYear[0]?.five">-</span>
                      <br>
                      &nbsp; <span class="years-share-text"> (Last 5 Years)</span>
                    </div>
                </div>
                  <span class="seperator"></span>
                  <hr class="hr-line">
                  <!-- <br> -->
                  <div class="align-h">
                    <div class="stretch">
                    <button type="button" (click)="investOnline()" class="common-submit-button-banner cursor-pointer">Invest Now</button>
                   </div>
                   <div>
                    <button type="button" id="invest-now" (click)="viewDetails(item.scheme, item)" class="common-submit-button-banner cursor-pointer btn-color-black margin-left-15">Explore</button>
                  </div>
                  </div>
                  <br><br>
                </div>
              </div>
            </ng-container>

            </div>
            <div class="no-fund text-center" *ngIf="otherCount<=0">No Funds available</div>
          </div>
        </div>
      <!-- </div> -->
    </div>
  </div>
</div>






<div class="products-main products-main-mobile content-mobile-section">
  <div class="col-lg-12 row p-0 mob-content-1">
    <div class="col-lg-12 row ">
    <div class="col-8 p-0 ">
    <select  class="select-data1" [(ngModel)]="activeTab" >
      <option value="all"> All Funds ({{fundsData.length}})</option>
      <option value="equity">  Equity Funds ({{equityCount}})</option>
      <option value="debt"> Debt Funds ({{debtCount}})</option>
      <option value="hybrid">  Hybrid Funds ({{hyBridCount}})</option>
      <option value="other">  Others ({{otherCount}})</option>
    </select>
    </div>
    <div class="col-2">
      <img src="assets/icons/icon_filter.png" (click)="setFilterSection(true)" class="m-filter">
      <span class="filters-header"></span>
    </div>
    <div class="col-2 ">
      <img  (click)="openPopUpScheme()" src="assets/icons/2arrow-t.png" class="scheme-icon-n">
    </div>
  </div>

    <div class="tab-content py-3 px-3 px-sm-0 col-lg-12 row" >
        <div class="col-12 p-0" *ngIf="viewFilters">
          <div class="col-lg-12 filters-section">
           <span class="close-filter" (click)="setFilterSection(false)">X</span>
           <span class="filters-header"> Filters</span>
            <hr>
            <span *ngFor="let item of filtersData;let lastMain=last">
              <span class="filter-sub-section">{{item.heading}}</span> <br>
              <div *ngFor="let subItem of item.datas;let i=index;let last=last">
                <input type="checkbox" class="filter-check-box cursor-pointer" [checked]="fundParams[item.name+'SelectionMap'] && fundParams[item.name+'SelectionMap'][subItem.value]" [value]="subItem.value" (change)="setMobileFilterOptionsFilters($event,item.name,subItem.value)">
                <span class="filter-check-box-text">{{subItem.displayName}}</span>
                <hr *ngIf="last && !lastMain">
              </div>
            </span>
            <hr>
            <a (click)="clearMobileFilters()"class="clear-filters"><u>Clear Filters</u></a>
            &nbsp;&nbsp;&nbsp;&nbsp;
            <button type="button" (click)="getFunds()"class="apply-filters">Apply</button>

          </div>
        </div>
        <div class="col-12 p-0"  *ngIf="!viewFilters">
          <div *ngIf="activeTab==='all'">
            <div class="col-lg-12 row p-0 m-0">
              <div class="col-lg-6  mobile-padding-top p-0" *ngFor="let item of fundsData;let i=index">
                <div class="col-lg-12 individual-funds">
                  <div class="top-right-corner"
                  [ngClass]="{'top-right-corner-l': item.risk==='Low', 'top-right-corner-mh': item.risk==='Moderate' || item.risk==='Moderately High'  || item.risk==='Moderately Low' || item.risk==='Low to Moderate','top-right-corner-m': item.risk==='High' || item.risk==='Very High'}"> 
                  <span class="risk-text">{{item.risk}} Risk</span>
                  </div>
                  <span class="fund-heading">{{item.fundType}}</span>
                  <span class="growth-section">  {{splitString(item.plan)}}</span>
                  <br>
                  <span class="fund-heading-2">{{item.scheme}} </span><br>
                  <span class="fund-text">{{item.description}}</span><br>
                  <hr class="hr-line">
                  <span class="fund-date" *ngIf="item.currentDate"> As on {{commonDataService.customDate(item.currentDate)}} </span><br>
                  <span class="fund-date" *ngIf="!item.currentDate"> NA </span><br>
                  <span class="date-text">NAV &nbsp; &#8377;   {{item.nav }}</span> &nbsp;
                   <img src="assets/icons/up_arrow.png" class="img-width" *ngIf="item.navPercent>=0">
       <img src="assets/icons/down_arrow.png" class="img-width" *ngIf="item.navPercent<0">
                  <span [ngClass]="{'date-vals': item.navPercent>=0,'date-vals-low': item.navPercent<0}">( {{item.navPercent | number : '1.2-2'}}% )</span>
                  <hr class="hr-line">
                  <span class="caption-cag">CAGR</span><br><br>
                  <div class="d-flex">
                    <div class="years-data">
                      <span *ngIf="item?.cagrYear[0]?.one"> 
                        <span class="years-share-val " [ngClass]="{'data-red': item.cagrYear[0].one<0,  'data-green': item.cagrYear[0].one>=0}" > 
                          <ng-template [ngIf]="item.cagrYear[0].one === 'NA'">
                            <span>NA</span>
                          </ng-template>
                          <ng-template [ngIf]="item.cagrYear[0].one !== 'NA'">
                            <span> {{item.cagrYear[0].one}}%</span>
                          </ng-template>
                        </span>
                      </span>
                      <span *ngIf="!item?.cagrYear[0]?.one">-</span>
                      <br>
                        <span class="years-share-text"> (Last 1 Year)</span>
                    </div>
                    <div class="years-data">
                      &nbsp;   <span *ngIf="item?.cagrYear[0]?.three">
                        <span class="years-share-val " [ngClass]="{'data-red': item.cagrYear[0].three<0,  'data-green': item.cagrYear[0].three>=0}"> 
                          <ng-template [ngIf]="item.cagrYear[0].three === 'NA'">
                            <span>NA</span>
                          </ng-template>
                          <ng-template [ngIf]="item.cagrYear[0].three !== 'NA'">
                            <span> {{item.cagrYear[0].three}}%</span>
                          </ng-template>
                        </span>
                      </span>
                      <span *ngIf="!item?.cagrYear[0]?.three">-</span>
                      <br>
                      &nbsp;<span class="years-share-text"> (Last 3 Years)</span>
                    </div>
                    <div class="years-data">
                      &nbsp;    <span *ngIf="item?.cagrYear[0]?.five">
                        <span class="years-share-val " [ngClass]="{'data-red': item.cagrYear[0].three<0,  'data-green': item.cagrYear[0].three>=0}"> 
                          <ng-template [ngIf]="item.cagrYear[0].five === 'NA'">
                            <span>NA</span>
                          </ng-template>
                          <ng-template [ngIf]="item.cagrYear[0].five !== 'NA'">
                            <span> {{item.cagrYear[0].five}}%</span>
                          </ng-template>
                        </span>
                      </span>
                      <span *ngIf="!item?.cagrYear[0]?.five">-</span>
                      <br>
                      &nbsp; <span class="years-share-text"> (Last 5 Years)</span>
                    </div>
                </div>
                  <span class="seperator"></span>
                  <hr class="hr-line">
                  <br>
                  <div class="align-h">
                    <div class="stretch">
                    <button type="button" (click)="investOnline()" class="common-submit-button-banner cursor-pointer">Invest Now</button>
                   </div>
                   <div>
                    <button type="button" id="invest-now" (click)="viewDetails(item.scheme, item)" class="common-submit-button-banner cursor-pointer btn-color-black margin-left-15">Explore</button>
                  </div>
                  </div>
                  <br><br>
                </div>
              </div>

            </div>
            <div class="no-fund text-center" *ngIf="!fundsData || fundsData.length<=0">No Funds available</div>
          </div>
          <div *ngIf="activeTab==='equity'">
            <div class="col-lg-12 row p-0">
              <ng-container  *ngFor="let item of fundsData;let i=index">
              <div class="col-lg-6 p-0 mobile-padding-top " *ngIf="item.fundType==='Equity'">
                <div class="col-lg-12 individual-funds">
                  <div class="top-right-corner"
                  [ngClass]="{'top-right-corner-l': item.risk==='Low', 'top-right-corner-mh': item.risk==='Moderate' || item.risk==='Moderately High'  || item.risk==='Moderately Low' ,'top-right-corner-m': item.risk==='High'}">
                    <span class="risk-text">{{item.risk}} Risk</span>
                  </div>
                  <span class="fund-heading">{{item.fundType}}</span>
                  <span class="growth-section">  {{splitString(item.plan)}}</span>
                  <br>
                  <span class="fund-heading-2">{{item.scheme}} </span><br>
                  <span class="fund-text">{{item.description}}</span><br>
                  <hr class="hr-line">
                  <span class="fund-date" *ngIf="item.currentDate"> As on {{commonDataService.customDate(item.currentDate)}} </span><br>
                  <span class="fund-date" *ngIf="!item.currentDate"> NA </span><br>
                  <span class="date-text">NAV &nbsp; &#8377;  {{item.nav }}</span> &nbsp;
                   <img src="assets/icons/up_arrow.png" class="img-width" *ngIf="item.navPercent>=0">
       <img src="assets/icons/down_arrow.png" class="img-width"  *ngIf="item.navPercent<0">
                  <span [ngClass]="{'date-vals': item.navPercent>=0,'date-vals-low': item.navPercent<0}">( {{item.navPercent | number : '1.2-2'}}% )</span>
                  <hr class="hr-line">
                  <span class="caption-cag">CAGR</span><br><br>
                  <div class="d-flex">
                    <div class="years-data">
                      <span *ngIf="item?.cagrYear[0]?.one"> 
                        <span class="years-share-val " [ngClass]="{'data-red': item.cagrYear[0].one<0,  'data-green': item.cagrYear[0].one>=0}" > 
                          <ng-template [ngIf]="item.cagrYear[0].one === 'NA'">
                            <span>NA</span>
                          </ng-template>
                          <ng-template [ngIf]="item.cagrYear[0].one !== 'NA'">
                            <span>{{item.cagrYear[0].one}}%</span>
                          </ng-template>
                        </span>
                      </span>
                      <span *ngIf="!item?.cagrYear[0]?.one">-</span>
                      <br>
                        <span class="years-share-text"> (Last 1 Year)</span>
                    </div>
                    <div class="years-data">
                      &nbsp;   <span *ngIf="item?.cagrYear[0]?.three">
                        <span class="years-share-val " [ngClass]="{'data-red': item.cagrYear[0].three<0,  'data-green': item.cagrYear[0].three>=0}"> 
                          <ng-template [ngIf]="item.cagrYear[0].three === 'NA'">
                            <span>NA</span>
                          </ng-template>
                          <ng-template [ngIf]="item.cagrYear[0].three !== 'NA'">
                            <span>{{item.cagrYear[0].three}}%</span>
                          </ng-template>
                        </span>
                      </span>
                      <span *ngIf="!item?.cagrYear[0]?.three">-</span>
                      <br>
                      &nbsp;<span class="years-share-text"> (Last 3 Years)</span>
                    </div>
                    <div class="years-data">
                      &nbsp;    <span *ngIf="item?.cagrYear[0]?.five">
                        <span class="years-share-val " [ngClass]="{'data-red': item.cagrYear[0].three<0,  'data-green': item.cagrYear[0].three>=0}"> 
                          <ng-template [ngIf]="item.cagrYear[0].five === 'NA'">
                            <span>NA</span>
                          </ng-template>
                          <ng-template [ngIf]="item.cagrYear[0].five !== 'NA'">
                            <span>{{item.cagrYear[0].five}}%</span>
                          </ng-template>
                        </span>
                      </span>
                      <span *ngIf="!item?.cagrYear[0]?.five">-</span>
                      <br>
                      &nbsp; <span class="years-share-text"> (Last 5 Years)</span>
                    </div>
                </div>
                  <span class="seperator"></span>
                  <hr class="hr-line">
                  <br>
                  <div class="align-h">
                    <div class="stretch">
                    <button type="button" (click)="investOnline()" class="common-submit-button-banner cursor-pointer">Invest Now</button>
                   </div>
                   <div>
                    <button type="button" id="invest-now" (click)="viewDetails(item.scheme, item)" class="common-submit-button-banner cursor-pointer btn-color-black margin-left-15">Explore</button>
                  </div>
                  </div>
                  <br><br>
                </div>
              </div>
            </ng-container>

            </div>
            <div class="no-fund text-center" *ngIf="equityCount<=0">No Funds available</div>
          </div>
          <div *ngIf="activeTab==='debt'">
            <div class="col-lg-12 p-0 row">
              <ng-container  *ngFor="let item of fundsData;let i=index">
              <div class="col-lg-6 p-0  mobile-padding-top " *ngIf="item.fundType==='Debt'">
                <div class="col-lg-12 individual-funds">
                  <div class="top-right-corner"
                  [ngClass]="{'top-right-corner-l': item.risk==='Low', 'top-right-corner-mh': item.risk==='Moderate' || item.risk==='Moderately High'  || item.risk==='Moderately Low' ,'top-right-corner-m': item.risk==='High'}">
                    <span class="risk-text">{{item.risk}} Risk</span>
                  </div>
                  <span class="fund-heading">{{item.fundType}}</span>
                  <span class="growth-section">  {{splitString(item.plan)}}</span>
                  <br>
                  <span class="fund-heading-2">{{item.scheme}} </span><br>
                  <span class="fund-text">{{item.description}}</span><br>
                  <hr class="hr-line">
                  <span class="fund-date" *ngIf="item.currentDate"> As on {{commonDataService.customDate(item.currentDate)}} </span><br>
                  <span class="fund-date" *ngIf="!item.currentDate"> NA </span><br>
                  <span class="date-text">NAV &nbsp; &#8377;  {{item.nav }}</span> &nbsp;
                   <img src="assets/icons/up_arrow.png" class="img-width" *ngIf="item.navPercent>=0">
       <img src="assets/icons/down_arrow.png" class="img-width" *ngIf="item.navPercent<0">
                  <span [ngClass]="{'date-vals': item.navPercent>=0,'date-vals-low': item.navPercent<0}">( {{item.navPercent | number : '1.2-2'}}% )</span>
                  <hr class="hr-line">
                  <span class="caption-cag">CAGR</span><br><br>
                  <div class="d-flex">
                    <div class="years-data">
                      <span *ngIf="item?.cagrYear[0]?.one"> 
                        <span class="years-share-val " [ngClass]="{'data-red': item.cagrYear[0].one<0,  'data-green': item.cagrYear[0].one>=0}" > 
                          <ng-template [ngIf]="item.cagrYear[0].one === 'NA'">
                            <span>NA</span>
                          </ng-template>
                          <ng-template [ngIf]="item.cagrYear[0].one !== 'NA'">
                            <span>{{item.cagrYear[0].one}}%</span>
                          </ng-template>
                        </span>
                      </span>
                      <span *ngIf="!item?.cagrYear[0]?.one">-</span>
                      <br>
                        <span class="years-share-text"> (Last 1 Year)</span>
                    </div>
                    <div class="years-data">
                      &nbsp;   <span *ngIf="item?.cagrYear[0]?.three">
                        <span class="years-share-val " [ngClass]="{'data-red': item.cagrYear[0].three<0,  'data-green': item.cagrYear[0].three>=0}"> 
                          <ng-template [ngIf]="item.cagrYear[0].three === 'NA'">
                            <span>NA</span>
                          </ng-template>
                          <ng-template [ngIf]="item.cagrYear[0].three !== 'NA'">
                            <span>{{item.cagrYear[0].three}}%</span>
                          </ng-template>
                        </span>
                      </span>
                      <span *ngIf="!item?.cagrYear[0]?.three">-</span>
                      <br>
                      &nbsp;<span class="years-share-text"> (Last 3 Years)</span>
                    </div>
                    <div class="years-data">
                      &nbsp;    <span *ngIf="item?.cagrYear[0]?.five">
                        <span class="years-share-val " [ngClass]="{'data-red': item.cagrYear[0].three<0,  'data-green': item.cagrYear[0].three>=0}"> 
                          <ng-template [ngIf]="item.cagrYear[0].five === 'NA'">
                            <span>NA</span>
                          </ng-template>
                          <ng-template [ngIf]="item.cagrYear[0].five !== 'NA'">
                            <span>{{item.cagrYear[0].five}}%</span>
                          </ng-template>
                        </span>
                      </span>
                      <span *ngIf="!item?.cagrYear[0]?.five">-</span>
                      <br>
                      &nbsp; <span class="years-share-text"> (Last 5 Years)</span>
                    </div>
                </div>
                  <span class="seperator"></span>
                  <hr class="hr-line">
                  <br>
                  <div class="align-h">
                    <div class="stretch">
                    <button type="button" (click)="investOnline()" class="common-submit-button-banner cursor-pointer">Invest Now</button>
                   </div>
                   <div>
                    <button type="button" id="invest-now" (click)="viewDetails(item.scheme, item)" class="common-submit-button-banner cursor-pointer btn-color-black margin-left-15">Explore</button>
                  </div>
                  </div>
                  <br><br>
                </div>
              </div>
            </ng-container>

            </div>
            <div class="no-fund text-center" *ngIf="debtCount<=0">No Funds available</div>
          </div>
          <div *ngIf="activeTab==='hybrid'">
            <div class="col-lg-12 p-0 row">
              <ng-container  *ngFor="let item of fundsData;let i=index">
              <div class="col-lg-6 p-0  mobile-padding-top " *ngIf="item.fundType==='Hybrid'">
                <div class="col-lg-12 individual-funds">
                  <div class="top-right-corner"
                  [ngClass]="{'top-right-corner-l': item.risk==='Low', 'top-right-corner-mh': item.risk==='Moderate' || item.risk==='Moderately High'  || item.risk==='Moderately Low' ,'top-right-corner-m': item.risk==='High'}">
                    <span class="risk-text">{{item.risk}} Risk</span>
                  </div>
                  <span class="fund-heading">{{item.fundType}}</span>
                  <span class="growth-section">  {{splitString(item.plan)}}</span>
                  <br>
                  <span class="fund-heading-2">{{item.scheme}} </span><br>
                  <span class="fund-text">{{item.description}}</span><br>
                  <hr class="hr-line">
                  <span class="fund-date" *ngIf="item.currentDate"> As on {{commonDataService.customDate(item.currentDate)}} </span><br>
                  <span class="fund-date" *ngIf="!item.currentDate"> NA </span><br>
                  <span class="date-text">NAV &nbsp; &#8377;  {{item.nav }}</span> &nbsp;
                   <img src="assets/icons/up_arrow.png" class="img-width" *ngIf="item.navPercent>=0">
       <img src="assets/icons/down_arrow.png" class="img-width" *ngIf="item.navPercent<0">
                  <span [ngClass]="{'date-vals': item.navPercent>=0,'date-vals-low': item.navPercent<0}">( {{item.navPercent | number : '1.2-2'}}% )</span>
                  <hr class="hr-line">
                  <span class="caption-cag">CAGR</span><br><br>
                  <div class="d-flex">
                    <div class="years-data">
                      <span *ngIf="item?.cagrYear[0]?.one"> 
                        <span class="years-share-val " [ngClass]="{'data-red': item.cagrYear[0].one<0,  'data-green': item.cagrYear[0].one>=0}" > 
                          <ng-template [ngIf]="item.cagrYear[0].one === 'NA'">
                            <span>NA</span>
                          </ng-template>
                          <ng-template [ngIf]="item.cagrYear[0].one !== 'NA'">
                            <span>{{item.cagrYear[0].one}}%</span>
                          </ng-template>
                        </span>
                      </span>
                      <span *ngIf="!item?.cagrYear[0]?.one">-</span>
                      <br>
                        <span class="years-share-text"> (Last 1 Year)</span>
                    </div>
                    <div class="years-data">
                      &nbsp;   <span *ngIf="item?.cagrYear[0]?.three">
                        <span class="years-share-val " [ngClass]="{'data-red': item.cagrYear[0].three<0,  'data-green': item.cagrYear[0].three>=0}"> 
                          <ng-template [ngIf]="item.cagrYear[0].three === 'NA'">
                            <span>NA</span>
                          </ng-template>
                          <ng-template [ngIf]="item.cagrYear[0].three !== 'NA'">
                            <span>{{item.cagrYear[0].three}}%</span>
                          </ng-template>
                        </span>
                      </span>
                      <span *ngIf="!item?.cagrYear[0]?.three">-</span>
                      <br>
                      &nbsp;<span class="years-share-text"> (Last 3 Years)</span>
                    </div>
                    <div class="years-data">
                      &nbsp;    <span *ngIf="item?.cagrYear[0]?.five">
                        <span class="years-share-val " [ngClass]="{'data-red': item.cagrYear[0].three<0,  'data-green': item.cagrYear[0].three>=0}"> 
                          <ng-template [ngIf]="item.cagrYear[0].five === 'NA'">
                            <span>NA</span>
                          </ng-template>
                          <ng-template [ngIf]="item.cagrYear[0].five !== 'NA'">
                            <span>{{item.cagrYear[0].five}}%</span>
                          </ng-template>
                        </span>
                      </span>
                      <span *ngIf="!item?.cagrYear[0]?.five">-</span>
                      <br>
                      &nbsp; <span class="years-share-text"> (Last 5 Years)</span>
                    </div>
                </div>
                  <span class="seperator"></span>
                  <hr class="hr-line">
                  <br>
                  <div class="align-h">
                    <div class="stretch">
                    <button type="button" (click)="investOnline()" class="common-submit-button-banner cursor-pointer">Invest Now</button>
                   </div>
                   <div>
                    <button type="button" id="invest-now" (click)="viewDetails(item.scheme, item)" class="common-submit-button-banner cursor-pointer btn-color-black margin-left-15">Explore</button>
                  </div>
                  </div>
                  <br><br>
                </div>
              </div>
            </ng-container>

            </div>
            <div class="no-fund text-center" *ngIf="hyBridCount<=0">No Funds available</div>
          </div>
          <div *ngIf="activeTab==='other'">
            <div class="col-lg-12 p-0 row">
              <ng-container  *ngFor="let item of fundsData;let i=index">
              <div class="col-lg-6 p-0 mobile-padding-top " *ngIf="item.fundType!=='Equity' && item.fundType!=='Debt' && item.fundType!=='Hybrid' ">
                <div class="col-lg-12 individual-funds">
                  <div class="top-right-corner"
                  [ngClass]="{'top-right-corner-l': item.risk==='Low', 'top-right-corner-mh': item.risk==='Moderate' || item.risk==='Moderately High'  || item.risk==='Moderately Low' ,'top-right-corner-m': item.risk==='High'}">
                    <span class="risk-text">{{item.risk}} Risk</span>
                  </div>
                  <span class="fund-heading">{{item.fundType}}</span>
                  <span class="growth-section">  {{splitString(item.plan)}}</span>
                  <br>
                  <span class="fund-heading-2">{{item.scheme}} </span><br>
                  <span class="fund-text">{{item.description}}</span><br>
                  <hr class="hr-line">
                  <span class="fund-date" *ngIf="item.currentDate"> As on {{commonDataService.customDate(item.currentDate)}}</span><br>
                  <span class="fund-date" *ngIf="!item.currentDate"> NA </span><br>
                  <span class="date-text">Nav &nbsp; &#8377;  {{item.nav }}</span> &nbsp;
                  <img src="assets/icons/up_arrow.png" class="img-width" *ngIf="item.navPercent>=0">
                  <img src="assets/icons/down_arrow.png" class="img-width"  *ngIf="item.navPercent<0">
                  <span [ngClass]="{'date-vals': item.navPercent>=0,'date-vals-low': item.navPercent<0}">( {{item.navPercent | number : '1.2-2'}}% )</span>
                  <hr class="hr-line">
                  <span class="caption-cag">CAGR</span><br><br>
                  <div class="d-flex">
                    <div class="years-data">
                      <span *ngIf="item?.cagrYear[0]?.one"> 
                        <span class="years-share-val " [ngClass]="{'data-red': item.cagrYear[0].one<0,  'data-green': item.cagrYear[0].one>=0}" > 
                          <ng-template [ngIf]="item.cagrYear[0].one === 'NA'">
                            <span>NA</span>
                          </ng-template>
                          <ng-template [ngIf]="item.cagrYear[0].one !== 'NA'">
                            <span>{{item.cagrYear[0].one}}%</span>
                          </ng-template>
                        </span>
                      </span>
                      <span *ngIf="!item?.cagrYear[0]?.one">-</span>
                      <br>
                        <span class="years-share-text"> (Last 1 Year)</span>
                    </div>
                    <div class="years-data">
                      &nbsp;   <span *ngIf="item?.cagrYear[0]?.three">
                        <span class="years-share-val " [ngClass]="{'data-red': item.cagrYear[0].three<0,  'data-green': item.cagrYear[0].three>=0}">
                           <ng-template [ngIf]="item.cagrYear[0].three === 'NA'">
                            <span>NA</span>
                          </ng-template>
                          <ng-template [ngIf]="item.cagrYear[0].three !== 'NA'">
                            <span>{{item.cagrYear[0].three}}%</span>
                          </ng-template>
                          </span>
                        </span>
                      <span *ngIf="!item?.cagrYear[0]?.three">-</span>
                      <br>
                      &nbsp;<span class="years-share-text"> (Last 3 Years)</span>
                    </div>
                    <div class="years-data">
                      &nbsp;    <span *ngIf="item?.cagrYear[0]?.five">
                        <span class="years-share-val " [ngClass]="{'data-red': item.cagrYear[0].three<0,  'data-green': item.cagrYear[0].three>=0}"> 
                          {{item.cagrYear[0].five}}%
                          <ng-template [ngIf]="item.cagrYear[0].five === 'NA'">
                            <span>NA</span>
                          </ng-template>
                          <ng-template [ngIf]="item.cagrYear[0].five !== 'NA'">
                            <span>{{item.cagrYear[0].five}}%</span>
                          </ng-template>
                        </span>
                      </span>
                      <span *ngIf="!item?.cagrYear[0]?.five">-</span>
                      <br>
                      &nbsp; <span class="years-share-text"> (Last 5 Years)</span>
                    </div>
                </div>
                  <span class="seperator"></span>
                  <hr class="hr-line">
                  <br>
                  <div class="align-h">
                    <div class="stretch">
                    <button type="button" (click)="investOnline()" class="common-submit-button-banner cursor-pointer">Invest Now</button>
                   </div>
                   <div>
                    <button type="button" id="invest-now" (click)="viewDetails(item.scheme, item)" class="common-submit-button-banner cursor-pointer btn-color-black margin-left-15">Explore</button>
                  </div>
                  </div>
                  <br><br>
                </div>
              </div>
            </ng-container>

            </div>
            <div class="no-fund text-center" *ngIf="otherCount<=0">No Funds available</div>
          </div>
        </div>
      <!-- </div> -->
    </div>
  </div>
</div>

